module.exports = __webpack_public_path__ + "static/feature-commands-af7aa0d8518cda69bb941a44a851db69.png";